import * as types from './types';

export default {
  [types.MUTATE_FIRST_CARD]: (state, isFirstCard) => {
    state.firstCard = isFirstCard;
  },
};
